import FileTypePrompts from '@/components/fileTypePrompts';
import { Grid } from '@mui/material';
import SettingsValidator from '../settingsValidators';
import SettingField from './sectionField';
import { SettingDivider } from './styledComponents';

type Props = {
  entityDefId: string;
  settings: Record<string, any>;
  settingsSection: any;
  errors: any;
  onChange: (settingName: string, value: any) => void;
};

const settingsValidator = new SettingsValidator();
const SettingsSection = ({ entityDefId, settings = {}, settingsSection = {}, errors, onChange }: Props) => {
  return (
    <Grid container spacing={1}>
      {settingsSection.sectionName && <SettingDivider label={settingsSection.sectionName} />}

      {settingsSection.items
        .filter((item: any) => settingsValidator.isItemVisible(item, settings))
        .map((item: any, idx: number) => {
          if (item.type === 'ftprompts') {
            return (
              <Grid sx={{ borderTop: idx > 0 ? 1 : 0, borderColor: 'divider' }} size={12} key={item.name}>
                <FileTypePrompts
                  key={item.name}
                  label="Prompts"
                  ftPrompts={settings[item.name]}
                  error={errors[item.name]}
                  onChange={(value: any) => onChange(item.name, value)}
                />
              </Grid>
            );
          } else {
            return (
              <SettingField
                key={item.name}
                entityDefId={entityDefId}
                settingDef={item}
                settings={settings}
                errors={errors}
                onChange={onChange}
                index={idx}
              />
            );
          }
        })}
    </Grid>
  );
};

export default SettingsSection;
